import { Button, Drawer, Modal } from "rsuite";
import { Icon } from "@rsuite/icons";
import { useEffect } from "react";
import "rsuite/dist/rsuite.min.css";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  allClientes,
  updateCliente,
  filterClientes,
  addClientes,
  unlinkClientes,
  resetClientes
} from "../../store/modules/cliente/actions";

const Clientes = () => {
  const dispatch = useDispatch();
  const { clientes, behavior, form, components, cliente } = useSelector(
    (state) => state.cliente
  );

  const setComponent = (component, state) => {
    dispatch(
      updateCliente({
        components: { ...components, [component]: state },
      })
    );
  };

  const setCliente = (key, value) => {
    console.log(value, key);
    dispatch(
      updateCliente({
        cliente: { ...cliente, [key]: value },
      })
    );
  };
  useEffect(() => {
    dispatch(allClientes());
  }, []);

  const save = () => {
    dispatch(addClientes());
  };

  const remove = () => {
   dispatch(unlinkClientes())
  };

  return (
    <div className="col p-5 h-100 overflow-auto">
      <Drawer
        open={components.drawer}
        size="sm"
        onClose={() => setComponent("drawer", false)}
      >
        <Drawer.Body>
          <h3>{behavior === "create" ? "Criar Novo" : "Atualizar"} cliente</h3>

          <div className="form-group col-12 mb-3">
            <b>Email</b>
            <div className="input-group ">
              <input
                type="email"
                disabled={behavior ==="update"}
                className="form-control"
                placeholder="E-mail do cliente"
                value={cliente.email}
                onChange={(e) => {
                  setCliente("email", e.target.value);
                }}
              />
             
               
               {behavior==="create" &&  (<div className="input-group-append">
                <Button
                  appearance="primary"
                  loading={form.filtering}
                  disabled={form.filtering}
                  onClick={() => dispatch(filterClientes())}
                >
                  Pesquisar
                </Button>
              </div>)}
            </div>
            <div className="row  mt-3">
              <div className="form-group col-6 ">
                <b className="">Nome</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nome do cliente"
                  disabled={form.disabled}
                  value={cliente.nome}
                  onChange={(e) => {
                    setCliente("nome", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-6 ">
                <b className="">email</b>
                <input
                  type="email"
                  className="form-control"
                  placeholder="email do cliente"
                  disabled={form.disabled}
                  value={cliente.email}
                  onChange={(e) => {
                    setCliente("email", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-6 ">
                <b className="">Data de Nacimiento</b>
                <input
                  type="date"
                  className="form-control"
                  placeholder="Nacimento do cliente"
                  disabled={form.disabled}
                  value={cliente.dataNacimento}
                  onChange={(e) => {
                    setCliente("dataNacimento", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-6 ">
                <b className="">telefone</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="telefone do cliente"
                  disabled={form.disabled}
                  value={cliente.telefone}
                  onChange={(e) => {
                    setCliente("telefone", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-6 ">
                <b className="">CPF</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="cpf do cliente"
                  disabled={form.disabled}
                  value={cliente.cpf}
                  onChange={(e) => {
                    setCliente("cpf", e.target.value);
                  }}
                />{" "}
              </div>
              <div className="form-group col-6 ">
                <b className="">CNH</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="CNH do cliente"
                  disabled={form.disabled}
                  value={cliente.cnh}
                  onChange={(e) => {
                    setCliente("cnh", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-3 mt-2 ">
                <b className="">Cidade</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Cidade do cliente"
                  disabled={form.disabled}
                  value={cliente.cidade}
                  onChange={(e) => {
                    setCliente("cidade", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-3 mt-2">
                <b className="">UF</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="UF do cliente"
                  disabled={form.disabled}
                  value={cliente.uf}
                  onChange={(e) => {
                    setCliente("uf", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-3 mt-2">
                <b className="">Cep</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Cep do cliente"
                  disabled={form.disabled}
                  value={cliente.cep}
                  onChange={(e) => {
                    setCliente("cep", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-3 mt-2 ">
                <b className="">Logradouro</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Logradouro do cliente"
                  disabled={form.disabled}
                  value={cliente.logradouro}
                  onChange={(e) => {
                    setCliente("logradouro", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-3 ">
                <b className="">Numero</b>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Numero do endereço"
                  disabled={form.disabled}
                  value={cliente.numero}
                  onChange={(e) => {
                    setCliente("numero", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-3 ">
                <b className="">Pais</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pais do cliente"
                  disabled={form.disabled}
                  value={cliente.pais}
                  onChange={(e) => {
                    setCliente("pais", e.target.value);
                  }}
                />
              </div>

              <div className="form-group col-3 ">
                <b className="">Sexo</b>
                <select
                  type="text"
                  className="form-control"
                  placeholder="sexo do cliente"
                  disabled={form.disabled}
                  value={cliente.sexo}
                  onChange={(e) => {
                    setCliente("sexo", e.target.value);
                  }}
                >
                  <option value="M">Masculino</option>
                  <option value="F">Feminino</option>
                </select>
              </div>
            </div>
          </div>
          <Button
            block
            className=" mt-3"
            color={behavior === "create" ? "green" : "red"}
            size="lg"
            loading={form.saving}
            onClick={() => {
              if (behavior === "create") {
                save();
              } else {
                setComponent("confirmDelete", true)
              }
            }}
          >
            {behavior === "create" ? "salvar" : "remover"} Cliente
          </Button>
        </Drawer.Body>
      </Drawer>

      <Modal
        open={components.confirmDelete}
        onHide={() => setComponent("confirmDelete", false)}
        size="xs"
      >
        <Modal.Body>
          <Icon
            icon="remind"
            style={{
              color: "@ffb300",
              fontSize: 24,
            }}
          />
          {"   "}Tem certeza que deseja excluir? Essa ação será inrreversivel!
        </Modal.Body>
        <Modal.Footer>
          <Button loading={form.saving} onClick={() => remove()} color="red">
            Sim, tenho certeza!
          </Button>
          <Button
            loading={form.saving}
            onClick={() => setComponent("confirmDelete", false)}
            appearance="subtle"
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="row">
        <div className="col-6">
          <div className="w-100 d-flex justify-content-between">
            <h2 className="mb-4 mt-0">Clientes</h2>
            <div>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  dispatch(resetClientes())
                  dispatch(
                    updateCliente({
                      behavior: "create",
                    })
                  );
                  setComponent("drawer", true);
                }}
              >
                <span className="mdi mdi-plus"> </span>
              </button>
            </div>
          </div>
          <Table
            loading={form.filtering}
            data={clientes}
            config={[
              {
                label: "nome",
                key: "nome",
                width: 200,
                fixed: true,
              },
              {
                label: "Email",
                key: "email",
                width: 200,
              },
              {
                label: "ciudade",
                key: "cidade",
                width: 200,
              },
              {
                label: "Telefone",
                key: "telefone",
                width: 200,
              },
              {
                label: "sexo",
                content: (item) =>
                  item.sexo === "M" ? "Masculino" : "Femenino",
                width: 200,
              },
            ]}
            actions={(clientes) => (
              <Button appearance="primary" size="xs">
                Ver informções
              </Button>
            )}
            onRowClick={(cliente) => {
              dispatch(
                updateCliente({
                  behavior: "update",
                })
              );
              setComponent("drawer", true);

              dispatch(updateCliente({ cliente }));
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Clientes;
